import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import * as data from '../../assets/static.json';

@Injectable({
  providedIn: 'root'
})

export class WebApiHttp {

  public globalurl: string = data.url;

  public ApiURLArray: any = {

    // User URL Start

    login: '/api/User/Login',
    Logout: '/api/User/Logout',
    createUser: '/api/User/CreateUser',
    roleProcess: '/api/Role/RoleProcess',
    signalRNotification: '/Notification',
    locationlist: '/api/User/LocationList',

    // User URL End

    //Masters
    getCountryMaster:'/api/Master/CountryMasterGet',
    insertCountryMaster:'/api/Master/CountryMasterInsert',
    deleteCountryMaster:'/api/Master/CountryMasterDelete?code=',

    getIndustryMaster:'/api/Master/IndustryMasterGet',
    insertIndustryMaster:'/api/Master/IndustryMasterInsert',
    deleteIndustryMaster:'/api/Master/IndustryMasterDelete?code=',

    getStateMaster:'/api/Master/StateMasterGet',
    insertStateMaster:'/api/Master/StateMasterInsert',
    deleteStateMaster:'/api/Master/StateMasterDelete?code=',

    getProductMaster:'/api/Master/ProductMasterGet',
    insertProductMaster:'/api/Master/ProductMasterInsert',
    deleteProductMaster:'/api/Master/ProductMasterDelete?code=',

    getReactionMaster:'/api/Master/ReactionMasterGet',
    insertReactionMaster:'/api/Master/ReactionMasterInsert',
    deleteReactionMaster:'/api/Master/ReactionMasterDelete?type=',

    getUserMaster:'/api/User/GetAllUser',
    insertUserMaster:'/api/User/CreateUser',
    deleteUserMaster:'/api/User/DeleteUser?id=',

    getLeadMaster:'/api/Master/LeadSourceMasterGet',
    insertLeadMaster:'/api/Master/LeadSourceMasterInsert',
    deleteLeadMaster:'/api/Master/LeadSourceMasterDelete?id=',

    getNoOfEmpMaster: '/api/Master/NumberOfEmployeeGet',
    insertNoOfEmpMaster: '/api/Master/NumberOfEmployeeInsert',
    deleteNoOfEmpMaster: '/api/Master/NumberOfEmployeeDelete?id=',

    getTurnOverMaster: '/api/Master/TurnOverMasterGet',
    insertTurnOverMaster: '/api/Master/TurnOverMasterInsert',
    deleteTurnOverMaster: '/api/Master/TurnOverMasterDelete?id=',

    getCompanyMaster:'/api/Master/CompanyMasterGet',
    insertCompanyMaster:'/api/Master/CompanyMasterInsert',
    updateCompanyMaster:'/api/Master/CompanyMasterUpdate',
    deleteCompanyMaster:'/api/Master/CompanyMasterDelete?company_code=',

    getContactMaster:'/api/Master/ContactPersonMasterGet?company_code=',
    insertContactMaster:'/api/Master/ContactPersonMasterInsert',
    updateContactMaster:'/api/Master/ContactPersonMasterUpdate',
    deleteContactMaster:'/api/Master/ContactPersonMasterDelete?id=',

    getInteraction:'/api/Interaction/InteractionGet?email=',
    insertInteraction:'/api/Master/InsteractionMasterInsert',
    deleteInteraction:'/api/Master/ContactPersonMasterUpdate',

    getDailyActivityDate:'/api/DailyActivity/DailyActivity_GetDate?created_by=',
    getDailyActivity:'/api/DailyActivity/DailyActivityGet?created_by=',
    insertDailyActivity:'/api/DailyActivity/DailyActivityInsert',
    deleteDailyActivity:'/api/DailyActivity/DailyActivityDelete?activity_code=',

  };

  constructor(private httpClient: HttpClient
  ) {}

  get getHTTPHeader(): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
  }

  getHTTPHeaderAuth(token: string): any {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
      })
    };
  }

  // post data to server
  async Post(path: string, jsondata: any): Promise<any> {
    try {
      path = this.globalurl + path;
      var headers = this.getHTTPHeader;
      return await new Promise<any>((resolve, reject) => {
        this.httpClient.post<any>(path, JSON.stringify(jsondata), headers).toPromise()
          .then(result => resolve(result), error => reject({
            condition: 'False',
            message: error.message
          })).catch(err => reject({condition: 'False', message: err.message}));
      });

    } catch (e) {
      return new Promise<any>((resolve) => {
        resolve({condition: 'False', message: e.message})
      });
    }
  }

  // get data to the server
  async Get(path: string): Promise<any> {
    try {
      path = this.globalurl + path;
      var headers = this.getHTTPHeader;
      return await new Promise<any>((resolve, reject) => {
        this.httpClient.get<any>(path, headers).toPromise()
          .then(result => resolve(result), error => reject({
            condition: 'False',
            message: error.message
          })).catch(err => reject({condition: 'False', message: err.message}));
      });
    } catch (e) {
      return new Promise<any>((resolve) => {
        resolve({condition: 'False', message: e.message})
      });
    }
  }

  getImageSrc(url: string) {
    try {
      if (url.includes('imageNotFound.png')) {
        return url;
      } else {
        return this.globalurl + '/' + url;
      }
    } catch (e) {
      return '';
    }
  }

  // For formdata
  async PostFormData(path: string, formdata: any): Promise<any> {
    try {
      path = this.globalurl + path;
      return await new Promise<any>((resolve, reject) => {
        this.httpClient.post<any>(path, formdata).toPromise()
          .then(result => resolve(result), error => reject({
            condition: 'false',
            message: error.message
          })).catch(error => reject({
          condition: 'false',
          message: error.message
        }))
      })

    } catch (e) {
      return new Promise<any>((resolve) => {
        resolve({condition: 'false', message: e.message})
      })
    }
  }

  // post data to server and get two type of response
  Post_Data_GetFile(path: string, jsondata: any) {
    path = this.globalurl + path;
    const request = new HttpRequest('POST', path, jsondata, {
      responseType: 'blob',
      reportProgress: true,
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    });
    return this.httpClient.request(request);
  }

  Get_Data_With_DownloadStatus_GetFile(path: string) {
    path = this.globalurl + path;
    const request = new HttpRequest('GET', path, {
      responseType: 'blob',
      reportProgress: true,
      headers: new HttpHeaders().append('Content-Type', 'application/json')
    });
    return this.httpClient.request(request);
  }

  blobToString(b) {
    var urldata, x;
    urldata = URL.createObjectURL(b);
    x = new XMLHttpRequest();
    x.open('GET', urldata, false); // although sync, you're not fetching over internet
    x.send();
    URL.revokeObjectURL(urldata);
    return x.responseText;
  }

}
